import axios from 'axios';
import { TEAM_USER_LIST } from '../../constants';

export const fetchTeamUserList = (search, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadTeamUserList());

  axios
    .get(`/admin/listUsers?searchString=${search}`, config)
    .then((res) => dispatch(setTeamUserList(res)))
    .catch((err) => {
      dispatch(errorTeamUserList(err.response));
      onError(err.response);
    });
};

export const loadTeamUserList = () => ({
  type: TEAM_USER_LIST.LOAD,
});

export const setTeamUserList = (userList) => ({
  type: TEAM_USER_LIST.SUCCESS,
  payload: userList.data.data,
});

export const errorTeamUserList = (error) => ({
  type: TEAM_USER_LIST.FAIL,
  payload: error,
});
